import { toDigitsOnly } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import { formatPhone } from 'commonUtils/formatters/formatPhone';

export class Phone {
  // eslint-disable-next-line no-empty-function
  constructor(private readonly phone: string | undefined) {}

  format() {
    if (!this.phone || !toDigitsOnly(this.phone)) {
      return undefined;
    }

    return formatPhone(this.phone);
  }
}
